export default function MessagePage() {
  return (
    <div className="placeholder-page">
      <h1>Display Messages in Broadcast</h1>
      <p>Coming soon!</p>
    </div>
  );
}
